import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const body: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};

export const box: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const label: SxStyle = {
  fontSize: (p) => `${p.typography.body4.fontSize} !important`,
  fontWeight: (p) => `${p.typography.fontWeightRegular} !important`,
  color: (p) => `${p.palette.grey[500]} !important`,
};
